import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 17",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.00001 3.83325L12.6667 8.49992L8 13.1666",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.33334 8.5L12.6667 8.5",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgArrow;
